import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  menuAuthorization: number;// 0 Admin 1 User

  constructor(private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    
    const currentUser = this.authService.currentUserValue;
    if (currentUser) {
      this.menuAuthorization = this.authService.currentUserValue.auth;
      let permission = this.applyMenuAuthorization(state.url);
      return permission;
    }
    else {
      // not logged in so redirect to login page with the return url
      this.authService.logout();
      return false;
    }
  }
  applyMenuAuthorization(url: string): boolean {
    if (this.menuAuthorization == 0) {
      switch (url) {
        case '/dashboard':
        case "/ecommerce/reports/general":
        case "/ecommerce/reports/temp-hum":
        case "/ecommerce/reports/fridge":
        case "/ecommerce/gaugesTest":
        case"/auth/logout":
          return true;
        default:
          return false;
      }
    }
    else
      return true;
  }
}
